import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function Level15Illustration({
  achievementId,
  variant = 'cosmic',
  // Unlocks cosmic variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3506">
      <div className="relative w-full h-full bg-gradient-to-br from-slate-900 via-indigo-950 to-purple-950 overflow-hidden" data-id="element-3507">
        {/* Background: Space, Nebula, Planets */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3508">
          {/* Nebula clouds */}
          <circle cx="40" cy="40" r="60" fill="#8B5CF6" opacity="0.2" filter="blur(15px)" data-id="element-3509" />
          <circle cx="160" cy="160" r="70" fill="#3B82F6" opacity="0.2" filter="blur(20px)" data-id="element-3510" />
          <circle cx="150" cy="50" r="50" fill="#EC4899" opacity="0.15" filter="blur(15px)" data-id="element-3511" />

          {/* Planet */}
          <circle cx="160" cy="40" r="20" fill="#FDE047" opacity="0.8" data-id="element-3512" />
          <path d="M130 50 Q160 30 190 50" stroke="#FEF08A" strokeWidth="4" strokeLinecap="round" fill="none" transform="rotate(-15 160 40)" data-id="element-3513" />

          {/* Distant stars */}
          <circle cx="30" cy="80" r="1" fill="white" data-id="element-3514" />
          <circle cx="80" cy="30" r="1.5" fill="white" data-id="element-3515" />
          <circle cx="120" cy="120" r="1" fill="white" data-id="element-3516" />
          <circle cx="50" cy="150" r="2" fill="white" data-id="element-3517" />
          <circle cx="180" cy="100" r="1.5" fill="white" data-id="element-3518" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-3519">
          <div className="w-[65%] h-[65%] flex items-center justify-center animate-[bounce_4s_ease-in-out_infinite]" data-id="element-3520">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'proud' : 'sleeping'} variant={variant} accessory="cosmicOrb" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3521" />
          </div>
        </div>

        {/* Foreground: Floating Asteroids and Magic */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3522">
            {/* Asteroids */}
            <path d="M20 120 L25 115 L35 118 L30 125 Z" fill="#64748B" data-id="element-3523" />
            <path d="M170 140 L180 135 L185 145 L175 150 Z" fill="#475569" data-id="element-3524" />
            <path d="M40 40 L45 35 L50 42 L42 45 Z" fill="#94A3B8" data-id="element-3525" />

            {/* Sparkles */}
            <path d="M140 80 L142 85 L147 87 L142 89 L140 94 L138 89 L133 87 L138 85 Z" fill="#A78BFA" data-id="element-3526" />
            <path d="M60 160 L61 163 L64 164 L61 165 L60 168 L59 165 L56 164 L59 163 Z" fill="#60A5FA" data-id="element-3527" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}